<!-- Le guide a son propre en-tête (titre, famille, photo) : pas de ligne de titre de
     feuille, la croix reste en haut à droite et l'en-tête lui laisse sa place. -->
<vw-toast-popup variant="full" [isOpen]="isOpen" toastCustomClass="bg-vw-bg"
  [ariaLabel]="$any(cultivationVariant?.name) || ''" (close)="onClose()">
  @if (cultivation && cultivationVariant) {
    <vw-cultivation-guide [plant]="plant" [cultivation]="cultivation" [inSheet]="true"
      [cultivationVariant]="cultivationVariant"></vw-cultivation-guide>
  }
</vw-toast-popup>
